import React from "react";
import { ReqOptionsContStyled } from "./reqOptions.styles";

import ReqOptionsStatus0 from "../reqOptions--status0/reqOptions--status0";
import ReqOptionsStatus2 from "../reqOptions--status2/reqOptions--status2";

const ReqOptions = ({ info }) => {
  // console.log(info ? info : null);

  const btns = () => {
    switch (info.status) {
      case 0:
        return <ReqOptionsStatus0 />;
      case 2:
        return <ReqOptionsStatus2 />;

      // default:
      //   return <ReqOptionsStatus2 />;

        break;
    }
  };

  return <ReqOptionsContStyled>{btns()}</ReqOptionsContStyled>;
};

export default ReqOptions;
